// extracted by mini-css-extract-plugin
export var productImage = "_zk-0";